import { lazy, Suspense, useEffect, useState } from "react";

const FloatingChat = lazy(() =>
  import("@/components/FloatingChat").then((m) => ({ default: m.FloatingChat })),
);
const Toaster = lazy(() => import("sonner").then((m) => ({ default: m.Toaster })));

/**
 * Componentes não-críticos do shell.
 * Monta apenas após o navegador ficar ocioso (ou na primeira interação),
 * tirando ~30-50KB de JS do caminho crítico do TTI mobile.
 */
export function DeferredUI() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;
    let cancelled = false;
    const arm = () => {
      if (!cancelled) setReady(true);
    };

    // Carrega na primeira interação do usuário (whichever first)
    const ric: number | null =
      "requestIdleCallback" in window
        ? (
            window as Window & {
              requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => number;
            }
          ).requestIdleCallback(arm, { timeout: 3000 })
        : null;
    const timer = window.setTimeout(arm, 2000);

    const events: (keyof WindowEventMap)[] = ["pointerdown", "keydown", "scroll"];
    events.forEach((e) => window.addEventListener(e, arm, { once: true, passive: true }));

    return () => {
      cancelled = true;
      if (ric !== null && "cancelIdleCallback" in window) {
        (window as Window & { cancelIdleCallback: (id: number) => void }).cancelIdleCallback(ric);
      }
      window.clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, arm));
    };
  }, [ready]);

  if (!ready) return null;

  return (
    <Suspense fallback={null}>
      <FloatingChat />
      <Toaster position="top-center" richColors />
    </Suspense>
  );
}
